export default __webpack_public_path__ + "static/media/0200.7c59f505.jpg";